import { render, staticRenderFns } from "./ComplexComponentRequirementItem.vue?vue&type=template&id=6adb64ac&scoped=true&"
import script from "./ComplexComponentRequirementItem.vue?vue&type=script&lang=js&"
export * from "./ComplexComponentRequirementItem.vue?vue&type=script&lang=js&"
import style0 from "./ComplexComponentRequirementItem.vue?vue&type=style&index=0&id=6adb64ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adb64ac",
  null
  
)

export default component.exports